// extracted by mini-css-extract-plugin
module.exports = {"Rows":"IntroVideoApp_Rows__1JeSy","Columns":"IntroVideoApp_Columns__2Lyq9","StarName":"IntroVideoApp_StarName__2Ext_","InfoStars":"IntroVideoApp_InfoStars__2ZuLA"};